import type { FaireProductEntity } from "../../entity_types/product";

export const p_zdnfh952dy: FaireProductEntity = {
  token: "p_zdnfh952dy",
  type: "product",
  name: "Melati Fresh Zero-Alcohol Botanical Spirit (with gift box)",
  brandToken: "b_5p3hx22es9",
  brandName: "Melati Drinks",
  imageUrl: "https://cdn.faire.com/fastly/4fb49019f6a6227ccc8e10b52b0a57337d18d30aa05105453d7a82e4adcbadae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/93fa50f91f4c38c4460e42f977e94aacaac09b9723498f69a992c7b7c61af48a.jpeg",
    "https://cdn.faire.com/fastly/91b3fe7552da6f9f60a2f7db38e0237f74d082c93316762cac63a836274512e8.jpeg",
    "https://cdn.faire.com/fastly/9d7ed34dbb70c416ce895c4ac82789688693c8a2b2413dc4d032c33d05765b28.jpeg"
  ],
  priceDollars: 45.73,
  description: "Melati Drinks is Asia's First Non-Alcoholic Spirit. Born out of the royal courts of the Far East, we uncovered botanical tonic recipes served since 1293. Travel through the magnificent volcanic highlands of Asia in a bold, delicious and healthy alcohol alternative. Savor uplifting goji berries, aromatic Asian spices and a long dry bitter finish. Let’s raise a glass to your health!\n\nEach bottle directly supports women's future in Indonesia and is ethically made within a circular economy.\n\nTropical, mineral and aromatic, Melati Fresh is a bold non-alcoholic spirit with bright acidity and a dry finish for white wine lovers. Tropical green mango, zesty lime rind and aromatic thai basil are grounded by warm Asian spices and cool fresh mint. Bright and complex, Fresh is best enjoyed with soda water in a champagne glass for a sophisticated drink.  \n\nComes with a beautiful gift box.",
  tags: [],
  msrpDollars: 62.36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:59.897Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
